import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { progressBarDriverFactory } from './ProgressBar.driver';
import { ProgressBar } from '.';

describe('ProgressBar', () => {
  const createDriver = createRendererWithUniDriver(progressBarDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<ProgressBar value={20} />);
    expect(await driver.exists()).toBe(true);
  });
});
